export default "__VITE_ASSET__B9AWg$Rv__"